import api from '@/store/api/contact'
import * as mutationTypes from './mutation-types'

// Modules
import propertyHistory from './property-history'

const initialState = () => ({
    contact: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        contact: state => state.contact
    },
    actions: {
        /**
         * @param {{contactId: number}} data
         * @returns {Promise<*>}
         */
        showContact: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showContact(data)
                commit(mutationTypes.SET_CONTACT, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        inviteUser: async ({dispatch}, data) => {
            try {
                const response = await api.inviteUser(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        inviteLegacy: async ({dispatch}, data) => {
            try {
                const response = await api.inviteLegacy(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        sendInvite: async ({dispatch}, data) => {
            try {
                const response = await api.sendInvite(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        revokeInvite: async ({dispatch}, data) => {
            try {
                const response = await api.revokeInvite(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        deactivateUser: async ({dispatch}, data) => {
            try {
                const response = await api.deactivateUser(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        deleteUser: async ({dispatch}, data) => {
            try {
                const response = await api.deleteUser(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        forcePasswordChange: async ({dispatch}, data) => {
            try {
                const response = await api.forcePasswordChange(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        sendPasswordReset: async ({dispatch}, data) => {
            try {
                const response = await api.sendPasswordReset(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        remove2Fa: async ({dispatch}, data) => {
            try {
                const response = await api.remove2Fa(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetContact: async ({commit}) => commit(mutationTypes.RESET_CONTACT)
    },
    mutations: {
        [mutationTypes.SET_CONTACT]: (state, data) => state.contact = data,
        [mutationTypes.RESET_CONTACT]: (state) => Object.assign(state, initialState())
    },
    modules: {
        propertyHistory
    }
}
